import React from "react";

const fm = new Intl.NumberFormat("es-MX", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const FormatCurrency = ({ value, prefix = "$", className = "" }) => {
  return (
    <span className={className}>
      {prefix} {fm.format(value)}
    </span>
  );
};

export default FormatCurrency;
